// extracted by mini-css-extract-plugin
export default {"tableQuickFiltersSectionHeader":"TableQuickFiltersSectionHeader_tableQuickFiltersSectionHeader__3wKAw"};